import { css } from '@emotion/react';
import { IonButton, IonIcon } from '@ionic/react';
import { linkOutline } from 'ionicons/icons';
import React from 'react';

interface CopyToClipboardButtonProps {
  textToCopy: string;
  onDidCopy?: () => void;
}

const CopyToClipboardButton: React.FC<CopyToClipboardButtonProps> = ({ textToCopy, onDidCopy }) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(textToCopy).then(() => onDidCopy?.());
  };

  const copyToClipboardButton = {
    button: [
      css({
        width: 32,
        height: 32,
        '--box-shadow': 'none',
        '--background-hover-opacity': '0.0',
      }),
    ],
    icon: [
      css({
        fontSize: '22px',
        '--ionicon-stroke-width': '48px',
      }),
    ],
  };

  return (
    <>
      <IonButton
        onClick={handleCopy}
        shape="round"
        color="warning"
        size="small"
        css={copyToClipboardButton.button}
        mode="md"
      >
        <IonIcon color="light" icon={linkOutline} slot="icon-only" css={copyToClipboardButton.icon} />
      </IonButton>
    </>
  );
};

export default CopyToClipboardButton;
